import MaintenanceTable from "features/maintenance/components/MaintenanceTable";
import MaintenanceDialog from "features/maintenance/components/MaintenanceDialog";

function GridForm(props) {
    const {
        resource,
        form,
        setForm,
        showValidation,
        items,
        filteredItems,
        handleEdit,
        onDelete,
        onCancel,
        handleSave,
        hasErrors,
        editableForm: EditableForm,
        dialogOpen,
        canSave,
        pageIcon,
        loading
    } = props;

    return (
        <>
            <MaintenanceTable
                columns={resource.columns}
                rows={filteredItems || []}
                onEdit={handleEdit}
                onDelete={onDelete}
                resource={resource}
                loading={loading}
            />
            <MaintenanceDialog
                open={dialogOpen}
                title={`${resource.singular}`}
                onCancel={onCancel}
                onSave={handleSave}
                canSave={canSave}
                icon={pageIcon}
                loading={loading}
            >
                <EditableForm
                    resource={resource}
                    form={form}
                    setForm={setForm}
                    showValidation={showValidation}
                    items={items}
                    loading={loading}
                />
            </MaintenanceDialog>
        </>
    );
}

export default GridForm;
